<template>
    <v-menu offset-y v-model="userMenu" :close-on-content-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on: activationEvents }">
            <v-tooltip :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" :disabled="utils.isMobile()" open-delay="500" bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <v-btn
                            tag="a"
                            class="link-menu"
                            :height="$vuetify.breakpoint.xs ? 30 : 46"
                            min-width="30"
                            :width="$vuetify.breakpoint.xs ? 30 : 50"
                            text
                            v-on="activationEvents"
                            @click="resetFormValidation"
                        >
                            <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-account-box-outline</v-icon>
                        </v-btn>
                    </span>
                </template>
                <span class="menuable__content__active-enter-active">
                    {{ $t('menu.account') }}
                </span>
            </v-tooltip>
        </template>

        <v-card v-if="user" width="350px" outlined>
            <v-list class="pt-0 pb-0">
                <v-list-item>
                    <v-list-item-content class="pl-2">
                        <v-list-item-title class="greyText">
                            <div class="py-2" style="float: left">
                                &#60;
                                <span class="bold font14 tbgreen-text" style="font-family: consolas, menlo, ubuntu mono, fira code">
                                    {{ user.login }}
                                </span>
                                /&#62;
                            </div>
                            <div class="pt-1" style="float: right">
                                <v-tooltip :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" :disabled="utils.isMobile()" open-delay="500" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            tag="a"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="link-menu"
                                            plain
                                            small
                                            @click="clickLogout()"
                                            style="max-width: 28px; min-width: 28px"
                                        >
                                            <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-power</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('menu.logout') }}</span>
                                </v-tooltip>
                            </div>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <AppMenuAccountBalanceInfo></AppMenuAccountBalanceInfo>

            <v-divider></v-divider>

            <AppMenuAccountChangeSettings></AppMenuAccountChangeSettings>

            <v-card-text class="py-2">
                <v-container class="font14 pl-4 pr-0">
                    <v-row>
                        <v-col cols="12" class="py-2 pl-1">
                            <span @click="showChangeOrderSettingsDialog" class="cursorPointer lightGreyText">
                                <v-icon class="pr-2" style="margin-bottom: 2px">mdi-cog-outline</v-icon>
                                {{ $t('menu.orderSettings') }}
                            </span>
                        </v-col>

                        <v-col v-if="config.isDepositWithdrawalEnabled === 1" cols="12" class="py-2 pl-1">
                            <span @click="showUploadDocumentsDialog" class="cursorPointer lightGreyText">
                                <v-icon class="pr-2" style="margin-bottom: 2px">mdi-cash-fast</v-icon>
                                {{ $t('menu.depositAndWithdrawals') }}
                            </span>
                        </v-col>

                        <v-col cols="12" class="py-2 pl-1">
                            <span @click="showChangePasswordDialog" class="cursorPointer lightGreyText">
                                <v-icon class="pr-2" style="margin-bottom: 2px">mdi-lock-reset</v-icon>
                                {{ $t('menu.changePassword') }}
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <AppMenuAccountUploadDocumentsDialog ref="uploadDocumentsDialog"></AppMenuAccountUploadDocumentsDialog>

            <AppMenuAccountDepositDialog ref="depositDialog"></AppMenuAccountDepositDialog>

            <!--            <AppMenuAccountChangeOrderSettingsDialog-->
            <!--                ref="changeOrderSettingsDialog"-->
            <!--            ></AppMenuAccountChangeOrderSettingsDialog>-->

            <AppMenuAccountChangePasswordDialog ref="changePasswordDialog"></AppMenuAccountChangePasswordDialog>

            <!--            <v-divider></v-divider>-->

            <AppMenuAccountChangeLocaleAndTimeZone></AppMenuAccountChangeLocaleAndTimeZone>

            <!--            <v-divider></v-divider>-->
        </v-card>
    </v-menu>
</template>
<style scoped></style>
<script>
    import { mapGetters, mapState } from 'vuex';
    import AppMenuAccountBalanceInfo from './AppMenuAccountBalanceInfo';
    import AppMenuAccountChangeSettings from './AppMenuAccountChangeSettings';
    import AppMenuAccountChangeLocaleAndTimeZone from './AppMenuAccountChangeLocaleAndTimeZone';
    import AppMenuAccountChangePasswordDialog from './AppMenuAccountChangePasswordDialog';
    import AppMenuAccountChangeOrderSettingsDialog from './AppMenuAccountChangeOrderSettingsDialog';
    import AppMenuAccountUploadDocumentsDialog from './AppMenuAccountUploadDocumentsDialog';
    import AppMenuAccountDepositDialog from './AppMenuAccountDepositDialog';
    import Constants from 'Helpers/constants';

    export default {
        name: 'app-menuAccountTB',
        components: {
            AppMenuAccountBalanceInfo,
            AppMenuAccountChangeSettings,
            AppMenuAccountChangeLocaleAndTimeZone,
            AppMenuAccountChangePasswordDialog,
            AppMenuAccountChangeOrderSettingsDialog,
            AppMenuAccountUploadDocumentsDialog,
            AppMenuAccountDepositDialog,
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            resetFormValidation() {
                if (this.$refs.setTimeZoneForm) {
                    this.$refs.setTimeZoneForm.$refs.form.resetValidation();
                }
            },
            showChangePasswordDialog() {
                this.$refs.changePasswordDialog.open();
            },

            showChangeOrderSettingsDialog() {
                this.$parent.$parent.$parent.$parent.$parent.$refs.changeOrderSettingsDialog.open();
            },
            showUploadDocumentsDialog() {
                if (this.user.owner_id && this.user.owner_id === Constants.AGENT_VIKTOR_TB_ID) {
                    this.$refs.depositDialog.open();
                } else {
                    this.$refs.uploadDocumentsDialog.open();
                }
            },
            clickLogout() {
                this.$store.dispatch('AuthModule/logout');
            },
        },

        computed: {
            ...mapGetters({
                getTimeZone: 'DictionariesModule/getTimeZone',
            }),
            ...mapState({
                config: (state) => state.AppModule.config,
            }),
            userMenu: {
                get() {
                    return this.$store.getters['MenuModule/getUserMenu'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setUserMenu', value);
                },
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
